import { DividerDesignTokens } from '@primeuix/themes/types/divider';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { tDeep } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/divider/index.ts
const dv = tDeep(componentCommon.divider);

export const DividerTelekomDT: DividerDesignTokens = {
  root: {
    borderColor: dv.border.color,
  },
  content: {
    background: dv.content.background,
    color: dv.content.color,
  },
  horizontal: {
    margin: `${dv.horizontal.margin.y} ${dv.horizontal.margin.x}`,
    padding: dv.horizontal.padding,
    content: {
      padding: `${dv.horizontal.content.padding.y} ${dv.horizontal.content.padding.x}`,
    },
  },
  vertical: {
    margin: `${dv.vertical.margin.y} ${dv.vertical.margin.x}`,
    padding: dv.vertical.padding,
    content: {
      padding: `${dv.vertical.content.padding.y} ${dv.vertical.content.padding.x}`,
    },
  },
};
